import onGetAIAssist from './onGetAiAssist';
import onGetAiPrompt from './onGetAiPrompt';

export default {
  onGetAIAssist,
  onGetAiPrompt,
};
